module.exports = __webpack_public_path__ + "img/logo-dark.26b88e28.png";